import { rpsAccountTypes } from '../../flows/front-office/shared/utils';
import {
  foNASURPSOMNIPrefixUrl,
  foNASURPSTRACPrefixUrl,
  foNASUROTHOMNIPrefixUrl,
  foNASUROTHTRACPrefixUrl
} from '../MFAccountFinderScreen/utils';
import config from '../../config';
import { navigateToExternal } from '../../core/util';

export const ocr504TimeoutText = toAccountTypeText =>
  `The new ${toAccountTypeText} IRA account has not established yet and may 
    take 2-3 minutes. Please check AWD to see if an item was created and if an 
    account number is included. If so, the account was successfully established.`;

export const ocrFailureText = toAccountTypeText =>
  `The new ${toAccountTypeText} IRA account was not established. 
  Please check AWD to see if an item was created. If so, please notify operations for 
  manual set up. If not, please close the flow, relaunch and re-submit the application.`;

export const ocrAccountFailureMessage = (toAccountTypeText, ocr504Timeout) => {
  const failureMsg = ocr504Timeout
    ? ocr504TimeoutText(toAccountTypeText)
    : ocrFailureText(toAccountTypeText);

  return failureMsg;
};

export const checkAccountNumberExist = (accounts = []) => {
  let noAccountNumberPresent = false;
  if (accounts.length === 0) return true;
  accounts.forEach(account => {
    if (account.accountNumber === '') {
      noAccountNumberPresent = true;
    }
  });
  return noAccountNumberPresent;
};

export const getS3PDFFileName = (s3FileName = '') => {
  if (s3FileName?.includes('/')) {
    const fileNameArray = s3FileName?.split('/');
    const fnArrLength = fileNameArray?.length || 0;
    return fnArrLength > 0 ? fileNameArray[fnArrLength - 1] : '';
  }
  return '';
};

const getAlternateOCRUrl = (accountType, bpId) => {
  switch (accountType) {
    case rpsAccountTypes.OMNI:
      // if traditional OMNI then return roth OMNI url
      return `${foNASUROTHOMNIPrefixUrl}?bpId=${bpId}&altOCRFlow=true`;
    case rpsAccountTypes.TRAC:
      // if traditional TRAC then return roth TRAC url
      return `${foNASUROTHTRACPrefixUrl}?bpId=${bpId}&altOCRFlow=true`;
    case rpsAccountTypes.ROTH_ROLLOVER_OMNI:
      // if roth OMNI then return traditional OMNI url
      return `${foNASURPSOMNIPrefixUrl}?bpId=${bpId}&altOCRFlow=true`;
    default:
      // default return traditional TRAC url
      return `${foNASURPSTRACPrefixUrl}?bpId=${bpId}&altOCRFlow=true`;
  }
};

export const redirectToAlternateOCRFlow = (accountType, bpId) => {
  const url = getAlternateOCRUrl(accountType, bpId);
  const fonasuUrlBase = config('internalReturnUrlPrefix');
  const fonasuUrl = `${fonasuUrlBase}${url}`;

  return navigateToExternal(fonasuUrl);
};
